import React from 'react'

const Video = () => {
    return (
        <>
            <section className="bg-accent section-space-less4" style={{backgroundColor:"#e7dedeff"}}>
                <div className="container">
                    <div className="row tab-space2 mt-lg-5">
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="img-overlay-70">
                                <div className="mask-content-sm">
                                    <div className="topic-box-sm color-pomegranate mb-20">पन्ना की ताज़ा खबरें</div>
                                    <h3 className="title-medium-light">
                                        <a to="single-news-3.html">Gym Fitness area coverded they Governed this in
                                            2017</a>
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <a className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
                                        <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
                                    </a>
                                </div>
                                <img src="/assets/img/news/news16.jpg" alt="news" className="img-fluid width-100" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="img-overlay-70">
                                <div className="mask-content-sm">
                                    <div className="topic-box-sm color-persian-green mb-20">पन्ना की ताज़ा खबरें</div>
                                    <h3 className="title-medium-light">
                                        <a to="single-news-3.html">Patricia Urquiola transparent furney Italia with
                                            iridescent</a>
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <a className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
                                        <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
                                    </a>
                                </div>
                                <img src="/assets/img/news/news17.jpg" alt="news" className="img-fluid width-100" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="img-overlay-70">
                                <div className="mask-content-sm">
                                    <div className="topic-box-sm color-web-orange mb-20">पन्ना की ताज़ा खबरें</div>
                                    <h3 className="title-medium-light">
                                        <a to="single-news-3.html">Denton Corker Marshall the myste biennale pavilion</a>
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <a className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
                                        <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
                                    </a>
                                </div>
                                <img src="/assets/img/news/news18.jpg" alt="news" className="img-fluid width-100" />
                            </div>
                        </div>
                    </div>
                    <div className="row tab-space2 mt-lg-5">
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="img-overlay-70">
                                <div className="mask-content-sm">
                                    <div className="topic-box-sm color-pomegranate mb-20">पन्ना की ताज़ा खबरें</div>
                                    <h3 className="title-medium-light">
                                        <a to="single-news-3.html">Gym Fitness area coverded they Governed this in
                                            2017</a>
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <a className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
                                        <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
                                    </a>
                                </div>
                                <img src="/assets/img/news/news16.jpg" alt="news" className="img-fluid width-100" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="img-overlay-70">
                                <div className="mask-content-sm">
                                    <div className="topic-box-sm color-persian-green mb-20">पन्ना की ताज़ा खबरें</div>
                                    <h3 className="title-medium-light">
                                        <a to="single-news-3.html">Patricia Urquiola transparent furney Italia with
                                            iridescent</a>
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <a className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
                                        <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
                                    </a>
                                </div>
                                <img src="/assets/img/news/news17.jpg" alt="news" className="img-fluid width-100" />
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 mb-4">
                            <div className="img-overlay-70">
                                <div className="mask-content-sm">
                                    <div className="topic-box-sm color-web-orange mb-20">पन्ना की ताज़ा खबरें</div>
                                    <h3 className="title-medium-light">
                                        <a to="single-news-3.html">Denton Corker Marshall the myste biennale pavilion</a>
                                    </h3>
                                </div>
                                <div className="text-center">
                                    <a className="play-btn popup-youtube" to="http://www.youtube.com/watch?v=1iIZeIy7TqM">
                                        <img src="/assets/img/banner/play.png" alt="play" className="img-fluid" />
                                    </a>
                                </div>
                                <img src="/assets/img/news/news18.jpg" alt="news" className="img-fluid width-100" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Video